export const CLASS_NAMES = {
    DROPDOWN: "js-dropdown",
    TRIGGER: "js-dropdownTrigger",
    TARGET: "js-dropdownTarget",
};
